module.exports = __webpack_public_path__ + "static/media/2.1f0322f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/2.png
// module id = 2109
// module chunks = 0